import { render, staticRenderFns } from "./smeUnderwriting.vue?vue&type=template&id=25441888&scoped=true&"
import script from "./smeUnderwriting.vue?vue&type=script&lang=js&"
export * from "./smeUnderwriting.vue?vue&type=script&lang=js&"
import style0 from "./smeUnderwriting.vue?vue&type=style&index=0&id=25441888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25441888",
  null
  
)

export default component.exports